export interface FacebookCursorWithPaginationType<T> {
    data: T[];
    pagination?: {
        before?: string;
        after?: string;
    };
}

export function withFacebookCursorPagination<T>(
    data: T[],
    pagination?: {
        before?: string;
        after?: string;
    },
): FacebookCursorWithPaginationType<T> {
    return {
        data,
        pagination,
    };
}
